import { useState, useEffect } from 'react';
import { useLoanContext } from '../contexts/LoanContext';
import InsuranceClaimList from '../components/InsuranceClaimList';
import LossDraftRepairDetails from '../components/LossDraftRepairDetails';

const LossDraftRepairPage = () => {
  const { loanNumber } = useLoanContext();
  const [selectedClaimId, setSelectedClaimId] = useState<string | null>(null);

  useEffect(() => {
    setSelectedClaimId(null);
  }, [loanNumber]);

  if (!loanNumber) {
    return null;
  }

  return (
    <>
      {selectedClaimId === null ? (
        <InsuranceClaimList loanNumber={loanNumber} onSelectClaim={setSelectedClaimId} />
      ) : (
        <LossDraftRepairDetails
          loanNumber={loanNumber}
          claimId={selectedClaimId}
          onBack={() => setSelectedClaimId(null)}
        />
      )}
    </>
  );
};

export default LossDraftRepairPage;
